import { updates } from '@/mocks/home';

const typeBadge: Record<string, { cls: string; icon: string; text: string }> = {
  hot: { cls: 'bg-primary-100 text-primary-700 border-primary-200/60', icon: 'ri-fire-line', text: '热门' },
  new: { cls: 'bg-accent-100 text-accent-700 border-accent-200/60', icon: 'ri-sparkling-line', text: '新番' },
};

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 bg-accent-100/70 text-accent-700 text-xs font-medium px-3 py-1 rounded-full mb-4">
            <i className="ri-flashlight-line text-xs"></i>
            <span>实时快讯</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            追更动态
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            实时追踪热门漫画最新更新，不错过任何一话精彩内容
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-primary-200/70">
            {updates.map((item, i) => {
              const badge = item.type ? typeBadge[item.type] : null;
              return (
                <div key={i} className={`relative pb-7 ${i === updates.length - 1 ? 'pb-0' : ''}`}>
                  <div className="absolute -left-[calc(0.5rem+1px)] top-0 w-4 h-4 rounded-full bg-primary-500 border-4 border-background-100 shadow-sm"></div>
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                    <span className="text-xs text-foreground-400 whitespace-nowrap font-medium min-w-[60px]">{item.time}</span>
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="inline-block px-2 py-0.5 text-xs font-medium rounded border border-secondary-200/60 bg-secondary-100 text-secondary-700 whitespace-nowrap">
                        {item.tag}
                      </span>
                      {badge && (
                        <span className={`inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded border whitespace-nowrap ${badge.cls}`}>
                          <i className={`${badge.icon} text-[10px]`}></i>
                          {badge.text}
                        </span>
                      )}
                    </div>
                    <span className="text-sm text-foreground-800 font-medium">{item.title}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}